interface EquipmentRentalCategoryBadge {
  /** ObjectId hex of the category — the row's only stored reference now. */
  _id: string;
  label: string;
  colorHex: string;
}

const DEFAULT_CATEGORY_HEX = '#82999C';

/** Map API `category_badges` into UI badges (snake_case → camelCase). */
function mapCategoryBadgesFromApi(raw: unknown): EquipmentRentalCategoryBadge[] {
  if (!Array.isArray(raw)) return [];

  const mappedBadges: EquipmentRentalCategoryBadge[] = [];
  for (const item of raw) {
    if (!item || typeof item !== 'object') continue;

    const rawBadge = item as Record<string, unknown>;
    const id = String(rawBadge._id ?? '').trim();
    if (!id) continue;

    const label = String(rawBadge.label ?? '').trim();
    const colorHex =
      String(rawBadge.color_hex ?? rawBadge.colorHex ?? DEFAULT_CATEGORY_HEX).trim() || DEFAULT_CATEGORY_HEX;
    mappedBadges.push({
      _id: id,
      label,
      colorHex,
    });
  }

  return mappedBadges;
}

/** Text color for category swatches (matches equipment-rental settings color badges). */
function categoryBadgeTextColor(hex: string): string {
  const normalized = String(hex ?? '')
    .replace('#', '')
    .trim()
    .toUpperCase();

  // Same exception as equipment-rental-categories.vue color dropdown.
  return normalized === 'F5F7F8' ? '#000000' : '#ffffff';
}

function categoryBadgeStyle(hex: string): Record<string, string> {
  const backgroundColor = hex?.trim() || DEFAULT_CATEGORY_HEX;

  return {
    backgroundColor,
    color: categoryBadgeTextColor(backgroundColor),
  };
}

export type { EquipmentRentalCategoryBadge };
export { mapCategoryBadgesFromApi, categoryBadgeTextColor, categoryBadgeStyle };
